module.exports = __webpack_public_path__ + "assets/img/kt-new.4a4e0646.png";